import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "fileInput",
    "fileInputContainer",
    "submitHelperText",
    "submit",
  ];
  declare fileInputTarget: HTMLInputElement;
  declare fileInputContainerTarget: HTMLElement;
  declare submitHelperTextTarget: HTMLElement;
  declare submitTarget: HTMLButtonElement;

  connect() {
    this.updateVisibility();
  }

  updateVisibility() {
    const selectedType = (
      this.element.querySelector(
        'select[name="stock_report[type]"]'
      ) as HTMLSelectElement
    )?.value;
    const isProbeBased = selectedType === "StockReport::ProbeBased";
    const hasUpload = this.inputHasUpload();

    if (hasUpload || !isProbeBased) {
      this.submitHelperTextTarget.classList.add("hidden");
      this.submitTarget.disabled = false;
    }

    if (isProbeBased && !hasUpload) {
      this.submitHelperTextTarget.classList.remove("hidden");
      this.submitTarget.disabled = true;
    }

    if (isProbeBased) {
      this.fileInputContainerTarget.classList.remove("hidden");
    } else {
      this.fileInputContainerTarget.classList.add("hidden");
    }
  }

  inputHasUpload() {
    const value = this.fileInputTarget.value;

    if (!value) {
      return false;
    }

    return value.trim() !== "";
  }
}
